"use strict";
/*
 * Created on 11 21 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Helper entity to process similar products.
 * @author VRu
 */


var SimilarProduct =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SimilarProduct, _DomainObject_1$Domai);

  /**
   * @param id
   * @param siteId
   * @param productId Internal id of product
   * @param similarProductId Internal id of similar product
   * @param processed defines whether an entity was processed (inserted or updated) by IDB importer.
   * Note that this information is used during the import only. Values of all entities are always set
   * to false at the end of the import.
   */
  function SimilarProduct(id, siteId, productId, similarProductId, processed) {
    var _this;

    _classCallCheck(this, SimilarProduct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimilarProduct).call(this));
    _this.id = id;
    _this.siteId = siteId;
    _this.productId = productId;
    _this.similarProductId = similarProductId;
    _this.processed = processed;
    return _this;
  }

  return SimilarProduct;
}(DomainObject_1.DomainObject);

exports.SimilarProduct = SimilarProduct;
/**
 * data schema
 */

SimilarProduct.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimilarProduct.name);
  return {
    id: builder.id('id'),
    siteId: builder.str('siteId'),
    productId: builder.str('productId'),
    similarProductId: builder.str('similarProductId'),
    processed: builder.bool('processed')
  };
}();